<template>
  <div>
    <el-upload
      :action="url"
      :headers="headers"
      :multiple="multiple"
      name="uploadFile"
      :data="{
        asImage: asImage,
        fieldName: fieldName,
        model: uplaodModel,
      }"
      :on-success="handleAvatarSuccess"
      :on-change="handleAvatarChange"
      :show-file-list="false"
    >
      <el-button
        :loading="loading"
        :disabled="loading"
        type="primary"
        :icon="icon"
        :size="size"
        >{{ topTitle }}</el-button
      >
    </el-upload>
  </div>
</template>
<script>
import projectConfig from "@/core/config";
import { getToken } from "@/utils";
export default {
  props: {
    // 图标
    topTitle: {
      type: Object,
      default: "导入",
    },
    // 图标
    icon: {
      type: Object,
      default: "el-icon-paperclip",
    },
    // 上传模块
    size: {
      type: Object,
      default: "small",
    },
    // 上传模块
    uplaodModel: {
      type: Object,
      default: "文件",
    },
    // 导入路径
    url: {
      type: String,
      default: projectConfig.baseUrl + "qingguang/cooperativesupplier/common/uploadDoc",
    },
    // 是否允许多个文件上传
    multiple: {
      type: Boolean,
      default: false,
    },
    // 文件类型是否是图片
    asImage: {
      type: Boolean,
      default: false,
    },
    fieldName: {
      type: String,
      default: "文件",
    },
  },
  data() {
    return {
      // projectConfig.baseUrl + "qingguang/tenantbussiness/common/upload",
      headers: { Authorization: getToken() },
      loading: false,
    };
  },
  created() {},
  methods: {
    handleAvatarSuccess(res, file) {
      this.$emit("handleAvatarSuccess", res, file);
    },
    handleAvatarChange(file, fileList) {
      this.loading = true;
      if (file.percentage == 100) {
        this.loading = false;
        this.$emit("handleAvatarChange", file);
      }
    },
  },
};
</script>
